import { useDispatch, useSelector } from 'react-redux';
import { REPORT_MODAL, TYPES } from 'app/constants/report';
import { LOGIN_MODAL, TYPES as LOGIN_TYPES } from 'app/constants/login';
import {
  openPostModalForEdit,
  openReportModal,
  openLoginModal,
} from 'app/dispatcher/modalDispatcher';
import ConfirmationModal from 'app/components/post/ConfirmationModal';
import get from 'lodash/get';
import {
  followPostRequest,
  deletePostRequest,
  pinPostRequest,
} from 'entity/post/postRedux';

const handleDeletePost = (onDelete, onCancel = () => {}) => {
  ConfirmationModal({
    title: 'Are you sure you want to delete post?',
    content: 'Post will be permanently removed.',
    okText: 'Confirm',
    cancelText: 'Cancel',
  }).then(onDelete, onCancel);
};

const usePostMenu = ({ postProps }) => {
  const {
    id,
    createdByCurrentUser,
    post,
    featuredComment,
    followedByCurrentUser,
    followersCount,
    group,
    campaignPostState,
  } = postProps;

  const isSignedIn = useSelector(state => state.auth.session.isSignedIn);
  const dispatch = useDispatch();
  const isAdminGroup = group?.slug === 'announcements';

  const isPostLocked = get(post, 'status') === 'lock';
  const answerId = get(featuredComment, 'id');

  const followText = followedByCurrentUser
    ? `Following (${followersCount})`
    : `Follow (${followersCount})`;

  const handleFollowClick = () => {
    if (!isSignedIn) {
      sessionStorage.setItem(
        'follow-question',
        JSON.stringify({ followableId: id }),
      );
      return dispatch(openLoginModal(LOGIN_MODAL[LOGIN_TYPES.FOLLOW_POST]));
    }

    dispatch(followPostRequest({ followableId: id }));
  };

  const reportClick = isPost => {
    const modalData = {
      id: isPost ? post.id : answerId,
      data: isPost ? REPORT_MODAL[TYPES.POST] : REPORT_MODAL[TYPES.ANSWER],
      commentableType: null,
    };
    const onClick = () => {
      if (!isSignedIn) {
        sessionStorage.setItem('new-report', JSON.stringify(modalData));
        return dispatch(openLoginModal());
      }
      dispatch(openReportModal(modalData));
    };
    return onClick();
  };

  const editOption = [
    {
      title: 'Edit',
      value: 'edit',
      onClick: () => dispatch(openPostModalForEdit(postProps)),
    },
  ];

  const ownOptions = [
    isAdminGroup && {
      title: campaignPostState === 'live' ? 'Unpin' : 'Pin',
      value: 'pin-post',
      onClick: () => {
        dispatch(
          pinPostRequest({
            id,
            pinType: campaignPostState === 'live' ? 'unpin' : 'pin',
          }),
        );
      },
    },
    {
      title: followText,
      value: 'follow-post',
      onClick: handleFollowClick,
    },
    ...(isPostLocked ? [] : editOption),
    {
      title: 'Delete',
      value: 'delete',
      onClick: () => handleDeletePost(() => dispatch(deletePostRequest(id))),
    },
  ];

  const publicOptions = [
    {
      title: followText,
      value: 'follow-post',
      onClick: handleFollowClick,
    },
    {
      title: 'Report',
      value: 'report-question',
      onClick: () => reportClick(true),
    },
  ];

  let menuOptions;
  if (createdByCurrentUser) {
    menuOptions = ownOptions;
  } else {
    menuOptions = publicOptions;
  }

  return menuOptions;
};

export default usePostMenu;
